import { JSONApi } from '../types';

export const isPlanAwaitingCancellation = (group: JSONApi.GroupResource) =>
  group.attributes.planCancellationRequested && group.attributes.planActive;
